import clsx from 'clsx'
import React, { FC } from "react"
import ReactDOM from "react-dom"
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"

import { ModalProps } from "../../utils/Interfaces"
import { Thematic } from "../../components/utils/Thematic"

export const SingleActionModal: FC<ModalProps> = ({ show, showOrHide, actionName, execAction, content, cancel, size, posting }) => {

    return ReactDOM.createPortal(
        <Dialog open={show} onClose={showOrHide} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 dark:bg-gray-900/60 backdrop-blur-sm bg-opacity-65 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className={
                            clsx(
                                size === 'sm' ? 'sm:max-w-sm' : null,
                                size === 'md' ? 'sm:max-w-md' : null,
                                size === 'lg' ? 'sm:max-w-lg' : null,
                                size === 'xl' ? 'sm:max-w-xl' : null,
                                size === '2xl' ? 'sm:max-w-2xl' : null,
                                size === '3xl' ? 'sm:max-w-3xl' : null,
                                size === '4xl' ? 'sm:max-w-4xl' : null,
                                size === '5xl' ? 'sm:max-w-5xl' : null,
                                size === '6xl' ? 'sm:max-w-6xl' : null,
                                "relative transform overflow-hidden rounded-lg bg-white dark:bg-slate-900 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                            )
                        }
                    >
                        <Thematic>
                            <div className="bg-white dark:bg-slate-900 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                {content}
                            </div>

                            <div className="bg-slate-100 dark:bg-slate-800 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <div className="w-full space-y-px">
                                    <div className="flex flex-row-reverse items-center align-middle">
                                        <button type="button" onClick={execAction} className="w-auto min-w-24 justify-center disabled:cursor-not-allowed text-sm rounded-md border border-transparent shadow-sm px-3 py-1.5 bg-orange-600 text-white disabled:text-white/80 hover:bg-orange-700 focus:outline-none" disabled={posting}>
                                            {
                                                posting ? (
                                                    <span className="flex flex-row items-center h-5 justify-center">
                                                        <i className="fad fa-spinner-third fa-xl fa-spin"></i>
                                                    </span>
                                                ) : (
                                                    actionName
                                                )
                                            }
                                        </button>

                                        {
                                            cancel && (
                                                <button type="button" className="text-sm flex-none shadow-none px-3 py-1 bg-inherit text-orange-600 hover:text-orange-700 hover:underline hover:cursor-pointer mr-2 sm:w-auto sm:text-sm" onClick={showOrHide}>
                                                    Cancel
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </Thematic>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>,
        document.getElementById('root')
    )
}